import {
  SectionStatsMap,
  coverStatsBySectionSelector,
} from 'selectors/routes/calendar/coverStatsBySectionSelector';
import { SectionsTables, TableSection } from 'types/tableBasedInventory';
import { StoreType } from '@tock/shared/utils/connect';
import { createSelector } from 'reselect';
import { getSectionLabelForTable } from 'utils/tableBasedTemplatesUtils';
import { groupBy, size } from 'es-toolkit/compat';
import {
  sortTablesWithinSectionByName,
  sortTablesWithinSectionByPriority,
} from 'utils/serviceTableUtils';
import calendarSquaresByTableAndTimeSelector, {
  AdditionalInventoryAndTablesWithSlots,
} from 'selectors/routes/calendar/calendarSquaresByTableAndTimeSelector';

function computeFlatTablesWithSlots(
  calendarSquaresByTableAndTime: AdditionalInventoryAndTablesWithSlots,
  coverStatsBySection: SectionStatsMap,
  timelineTablesSortByPriority: boolean
): SectionsTables {
  const sections = groupBy(calendarSquaresByTableAndTime.tablesWithSlots, (tableWithSlots) => {
    return getSectionLabelForTable(tableWithSlots);
  });

  const flatTablesAndSections: SectionsTables = [];

  const sortedSectionLabels = Object.keys(sections).sort(
    (sectionLabel: string, sectionLabel2: string) => {
      const sectionLabelUpper = sectionLabel.toUpperCase(); // ignore upper and lowercase
      const sectionLabel2Upper = sectionLabel2.toUpperCase(); // ignore upper and lowercase
      if (sectionLabelUpper < sectionLabel2Upper) {
        return -1;
      }
      if (sectionLabelUpper > sectionLabel2Upper) {
        return 1;
      }

      // names must be equal
      return 0;
    }
  );

  sortedSectionLabels.forEach((sectionLabel: string) => {
    const tables = sections[sectionLabel];
    if (size(tables) > 0) {
      const section: TableSection = {
        type: 'section',
        label: sectionLabel,
        totalCovers: coverStatsBySection[sectionLabel],
      };
      const sortedTablesAndTableGroups = timelineTablesSortByPriority
        ? sortTablesWithinSectionByPriority(tables)
        : sortTablesWithinSectionByName(tables);
      flatTablesAndSections.push(section);
      sortedTablesAndTableGroups.forEach((section) => flatTablesAndSections.push(section));
    }
  });

  return flatTablesAndSections;
}

export const flatTablesWithSlotsSelector = createSelector(
  calendarSquaresByTableAndTimeSelector,
  coverStatsBySectionSelector,
  (state: StoreType) => {
    const currentBusinessId = state.app.activeBusiness.id;
    return (
      state.dashboardPreferences?.[currentBusinessId]?.data?.timelineTablesSortByPriority ?? false
    );
  },
  computeFlatTablesWithSlots
);
